/**
 * @description
 * fake id for new role that is just in the process of creation on frontend
 */
export const NEW_ROLE_ID_STUB = 'new';
